import { useTranslation } from "react-i18next";

import SittingPerson from "@/assets/common/other_icons/sitting-person.svg?react";
import useSegmentEvent from "@/hooks/useSegmentEvent";

import BaseCard, { ActionButton } from "./BaseCard";

function Academy() {
  const { t } = useTranslation(["common", "communicate"]);
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <BaseCard
      Icon={SittingPerson}
      title={t("communicate:academy.title")}
      text={t("communicate:academy.text")}
      orientation="vertical"
    >
      <ActionButton
        to="https://academy.hellocarbo.com/course/communication-carbone"
        shouldOpenNewTab
        onClick={() => sendSegmentEvent("academy_comcarbone_communication")}
      >
        {t("common:start")}
      </ActionButton>
    </BaseCard>
  );
}

export default Academy;
